import {useRef, useState} from 'react';
import {AnimatePresence, motion} from 'motion/react';
import {publishEvent} from '@udemy-v2/event-tracking';

import {ContentInnovationCoursePreviewSelected} from './events';
import assetLoader from '@/utils/asset-loader';

import styles from './featured-courses.module.scss';

let eventPublished = false;

function VideoPlayer() {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isPaused, setIsPaused] = useState(true);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setIsPlaying(true);
            setIsPaused(false);
        }

        if (!eventPublished) {
            publishEvent(new ContentInnovationCoursePreviewSelected());
            eventPublished = true;
        }
    };

    return (
        <div className={styles.videoContainer}>
            <video
                onPlay={handlePlay}
                controlsList="nodownload"
                controls={isPlaying}
                playsInline
                onPause={() => setIsPaused(true)}
                onEnded={() => {
                    setIsPlaying(false);
                    if (videoRef.current) {
                        videoRef.current.load();
                    }
                }}
                ref={videoRef}
                className={styles.video}
                poster={assetLoader({
                    src: '/ci/images/landing/placeholders/video/thumbnail.jpg',
                })}
            >
                <source
                    src={assetLoader({
                        src: 'ci/videos/ai_for_business_leaders_1080p.webm',
                    })}
                    type="video/webm"
                />
            </video>
            <AnimatePresence>
                {!isPlaying || isPaused ? (
                    <motion.div
                        className={styles.playButton}
                        onClick={handlePlay}
                        initial={{opacity: 0}}
                        animate={{opacity: 1}}
                        transition={{duration: 0.3, ease: 'easeInOut'}}
                        exit={{opacity: 0}}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="54"
                            height="54"
                            viewBox="0 0 54 54"
                            fill="none"
                        >
                            <circle cx="27" cy="27" r="27" fill="white" />
                            <path
                                d="M22.8496 19.001L38.0003 27.3489L22.8496 35.6995L22.8496 27.3503L22.8496 19.001Z"
                                fill="black"
                            />
                        </svg>
                    </motion.div>
                ) : null}
            </AnimatePresence>
        </div>
    );
}

export default VideoPlayer;
